<button (click)="openConfig.emit()" class="config-panel-toggle" color="primary" mat-fab type="button">
  <mat-icon [icIcon]="icSettings"></mat-icon>
</button>
